import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  wrestlingPageAdditionalMeta,
  wrestlingPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/main-half.png';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import WrestlingPageMainContainer from '../../components/wrestling/WrestlingPageMainContainer';
import ServiceHeader from '../../components/general/ServiceHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function WrestlingPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Session Wrestling'
        desc={`Experience the thrill of session wrestling with ${CompanyName}. Strength, dominance, and skill collide in an electrifying battle of power.`}
        keywords={KeywordsPages}
        additionalMeta={wrestlingPageAdditionalMeta}
        structuredData={wrestlingPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <ServiceHeader
            title={`Wrestling`}
            subtitle={`Think you can take my choke hold?`}
            imageUrl={`bg-wrestling`}
          />

          {/* Main page content */}
          <WrestlingPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default WrestlingPage;
